<template>
  <Layout no-header>
    <CreateAccountForm></CreateAccountForm>
  </Layout>
</template>
<script>
import CreateAccountForm from '@/components/auth/CreateAccountForm'
import Layout from '@/components/layout/Layout'

export default {
  components: { CreateAccountForm, Layout }
}
</script>
